import { Box, Heading, Paragraph } from '@zillow/constellation-10';
import { cva } from '@/styled-system/css';

interface IconBoxProps {
  children: React.ReactNode;
  backgroundColor: string;
}

const customColorRecipe = cva({
  base: {
    backgroundColor: 'bg.feedback.success.impact',
    width: '{spacing.1400}',
    height: '{spacing.1400}',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  variants: {
    color: {
      green: {
        backgroundColor: 'bg.feedback.success.impact',
      },
      black: {
        backgroundColor: 'bg.feedback.info.impact',
      },
    },
  },
});

const IconBox = ({ children, backgroundColor }: IconBoxProps) => {
  return <Box css={customColorRecipe.raw({ color: backgroundColor as 'green' | 'black' })}>{children}</Box>;
};

interface BenefitSectionProps {
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
  backgroundColor: string;
}

export const BenefitSection = ({ icon, title, children, backgroundColor }: BenefitSectionProps) => {
  return (
    <Box css={{ display: 'flex', gap: '{spacing.400}', alignItems: 'flex-start', marginBottom: '{spacing.800}' }}>
      <IconBox backgroundColor={backgroundColor}>{icon}</IconBox>
      <Box css={{ flex: 1 }}>
        <Heading
          level={4}
          css={{
            fontSize: '{fontSizes.500}',
            fontWeight: '800',
            marginBottom: '{spacing.200}',
            lineHeight: '{fontSizes.500}',
          }}
        >
          {title}
        </Heading>
        <Paragraph>{children}</Paragraph>
      </Box>
    </Box>
  );
};
